<template>
    <section id="default-page">
        <div class="container full-width">
            <div class="row" v-if="selected_search">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                Edit Search
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="search col-md-12 col-lg-6">
                    <div class="form-group">
                        <label for="saveSearch">Name</label>
                        <input type="text" id="saveSearch" class="form-control" placeholder="Search Name" v-model="selected_search.name">
                    </div>
                    <div class="container-search pr-0">
                        <vehicle-search-form :hide_search_fields="true"></vehicle-search-form>
                    </div>
                </div>
                <div class="users col-md-12 col-lg-6">
                    <div class="user-list-container">
                        <b-table
                                class="list-table favourite-list-user-table"
                                :fields="user_fields"
                                :items="selected_search.users"
                                show-empty
                        >
                            <template v-slot:empty="scope">
                                No members are added to list...
                            </template>
                            <template v-slot:cell(name)="data">
                                <span>{{data.item.name}}
                                    <template v-if="data.item.company">
                                        ({{data.item.company.name}})
                                    </template>
                                </span>
                                <span class="remove-member" :id="`removeuser-${data.item.id}`">
                                    <icon icon=" fa-minus-circle"></icon>
                                </span>
                                <b-popover :ref="`removeuser-${data.item.id}`"
                                           :target="`removeuser-${data.item.id}`" triggers="click">
                                    <div class="my-list-popover">
                                        Are you sure you want to remove this member from the list?
                                        <br/>
                                        <a @click="removeMember(data.item)" class="yes">Yes</a>
                                        <a @click="closeToolTip(`removeuser-${data.item.id}`)" class="no">No</a>
                                    </div>
                                </b-popover>
                            </template>
                            <template v-slot:cell(sendEmail)="data">
                                    <span class="checkbox">
                                        <input type="checkbox" :id="'send_email-'+data.item.id"
                                               v-model="data.item.pivot.send_email">
                                        <label :for="'send_email-'+data.item.id"></label>
                                    </span>
                            </template>
                            <template v-slot:cell(recommend)="data">
                                    <span class="checkbox">
                                        <input type="checkbox" :id="'recommend-'+data.item.id"
                                               v-model="data.item.pivot.recommend">
                                        <label :for="'recommend-'+data.item.id"></label>
                                    </span>
                            </template>

                        </b-table>
                        <div class="row" style="padding: 0px 15px;">
                            <div class="col-md-12 member">
                                <div v-if="addUserButton" class="row">
                                    <div class="col-md-12 list-actions">
                                        <a @click.prevent="addMember()" class="add-button link"
                                           href="#!">
                                            Add Member
                                            <icon icon=" fa-plus-circle"></icon>
                                        </a>
                                    </div>
                                </div>
                                <div class="row" v-if="addUser">
                                    <div class="col-md-6 col-ms-12 d-flex align-items-center justify-content-start input-area">
                                        <input ref="user_search_input" type="text" name="userName"
                                               placeholder="Start typing to search"
                                               v-on:keyup="getUsers()" id="userName" v-model="userName"
                                               class="textbox w-100"/>
                                        <a @click.prevent="cancelAddMember()" href="#!">
                                            <icon icon=" fa-times ml-2"></icon>
                                        </a>
                                    </div>
                                    <div class="col-md-6 d-flex align-items-center">
                                        <span class="checkbox">
                                            <input type="checkbox" name="sales_rep" id="sales-rep" v-model="salesRep" @input="getUsers()"/>
                                            <label for="sales-rep">Filter by Sales Rep</label>
                                        </span>
                                    </div>

                                </div>
                                <div class="row user-detail" v-if="getUserList">
                                    <div class="col-md-12" v-for="user in getUserList">
                                        <div class="row detail">
                                            <div class="col-md-6">
                                                <span class="member-name">{{user.name}}</span>
                                                <span v-if="user.company">({{user.company.name}})</span>
                                            </div>
                                            <div class="col-md-6 link">
                                                <a @click="saveUser(user)" class="save-list">Add</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="buttons col-md-12 mt-2">
                    <div class="container-buttons">
                        <a href="#" class="btn btn-primary" @click="saveSearch">Save</a>
                        <button type="submit" class="btn btn-primary" @click="closeEditForm">Cancel</button>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                Auto Notices
                            </h2>
                        </div>
                    </div>
                    <div class="bottom">
                        <span v-if="total > 0">
                            <strong>Showing</strong>
                            <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                            results
                        </span>
                    </div>
                </div>
                <div class="container-table">
                    <b-table
                            id="autonotices"
                            responsive=""
                            class="list-table"
                            :fields="fields"
                            :items="auto_notices"
                            show-empty
                    >
                        <template v-slot:empty="scope">
                            You have no auto notices...
                        </template>
                        <template v-slot:cell(created_at)="data">
                            <div class="search-name">
                                {{data.item.name}}
                            </div>
                            {{dateFormat(data.item.created_at)}}
                        </template>
                        <template v-slot:cell(transmission)="data">
                            <template v-if="data.item.search.transmission === 1">Manual</template>
                            <template v-else-if="data.item.search.transmission === 2">Automatic</template>
                            <template v-else-if="data.item.search.transmission === 0">Unknown</template>
                            <template v-else>All</template>
                        </template>
                        <template v-slot:cell(make)="data">
                            <span v-if="data.item.search && data.item.search.makes">
                                <template v-for="(make, i) in data.item.search.makes">
                                    <template v-if="i > 0">,</template>
                                    {{make.name}}
                                </template>
                            </span>
                        </template>
                        <template v-slot:cell(rec)="data">
                            <span>{{countPivot(data.item.users, 'recommend')}}</span>
                        </template>
                        <template v-slot:cell(email)="data">
                            <span>{{countPivot(data.item.users, 'send_email')}}</span>
                        </template>
                        <template v-slot:cell(exclude_make)="data">
                            <template v-if="data.item.search && data.item.search.exclude_make && data.item.search.exclude_make.length">
                                    <span v-for="(make, index) in data.item.search.exclude_make">
                                        {{make.label}}<template v-if="(index+1) < data.item.search.exclude_make.length">, </template>
                                    </span>
                                <br />
                            </template>
                            <template v-if="data.item.search && (data.item.search.exclude_year_min || data.item.search.exclude_year_max)">
                                {{minMax(null, 'exclude_year', data.item)}}
                            </template>
                        </template>
                        <template v-slot:cell(model)="data">
                            <template v-if="data.item.search && data.item.search.models">
                                    <span v-for="(model, index) in data.item.search.models">
                                        {{model.name}}<template v-if="(index+1) < data.item.search.models.length">, </template>
                                    </span>
                            </template>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <a href="#" @click="editAutoNotice(data.item)" class="link auto-notices-actions">Edit</a>
                            <a href="#" @click.stop.prevent="loadAutoNotice(data.item)" class="link auto-notices-actions">Load</a>
                            <a href="#" @click.stop.prevent="searchAutoNotice(data.item)" class="link auto-notices-actions">Search</a>
                            <a href="#" @click.stop.prevent="nextDayAutoNotice(data.item)" class="link auto-notices-actions">+1</a>
                            <a class="drop" :id="`confirmDeleteList-${data.item.id}`" @click="openDeletePopper(data.item.id)"></a>
                            <b-popover :show.sync="confirmDelete[data.item.id]"
                                       :target="`confirmDeleteList-${data.item.id}`" triggers="click">
                                <div class="my-list-popover">
                                    This will delete the list along with it's members and vehicles. Are you
                                    sure?
                                    <br/>
                                    <a @click="deleteSearch(data.item)" class="yes">Yes</a>
                                    <a @click="confirmDelete[data.item.id] = false" class="no">No</a>
                                </div>
                            </b-popover>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {getExceptionErrorMessage, searchDataFromModel} from '../../util/common'
    import _ from 'underscore'
    import moment from 'moment'
    export default {
        async mounted(){
            //TODO move the edit form to another component and load it with routes.js to allow history api to work.
            let data = await this.getData();
            if (this.$route.params.id) {
                let id = parseInt(this.$route.params.id)
                this.auto_notices.forEach(autonotice => {
                    if (id === autonotice.id) {
                        this.openEditForm(autonotice)
                    }
                })
            }
        },
        data() {
            return {
                userSearchCancelToken: null,
                selected_search: null,
                sendEmail: [],
                recommend: [],
                getUserList: [],
                userName: '',
                addUser: false,
                confirmDelete: {},
                addUserButton: true,
                userListActive: false,
                fields: [
                    {label: 'Saved',    key: 'created_at', sortable: false},
                    {label: 'Make',     key: 'make', sortable: false},
                    {label: 'Model',    key: 'model', sortable: false},
                    {label: 'Year',     key: 'year',        formatter: 'minMax'},
                    {label: 'Cond',     key: 'condition',   formatter: 'minMax'},
                    {label: 'Mileage',  key: 'mileage',     formatter: 'minMax'},
                    {label: 'Trans',    key: 'transmission'},
                    {label: 'Chassis',  key: 'search.chassis'},
                    {label: 'Exclude',  key: 'exclude_make',},
                    {label: 'CC',       key: 'engine_cc',   formatter: 'minMax'},
                    {label: 'Fuel',     key: 'search.fuel_type'},
                    {label: 'Bid',      key: 'start_bid',   formatter: 'minMax'},
                    {label: 'Lot',      key: 'search.lot'},
                    {label: '# Rec',    key: 'rec'},
                    {label: '# Email',  key: 'email'},
                    {label: '', key: 'actions', class: 'action-buttons', tdClass(value, key, item){
                        let classes = ''
                        if (item.last_searched) {
                            let now = moment()
                            let last = moment(item.last_searched)
                            if (now.isSame(last, 'day')) {
                                classes = 'searched'
                            }

                        }
                        return classes
                    }}
                ],
                user_fields: [
                    {label: 'Members', key: 'name',},
                    {label: 'Send Email', key: 'sendEmail'},
                    {label: 'Recommend', key: 'recommend'},
                ],
                salesRep: false
            }
        },
        computed: {
            ...mapState({
                selected_models: state => state.auction_search.selected_models,
                auto_notices: state => state.auto_notices.all,
                per_page: state => state.auto_notices.per_page,
                from: state => state.auto_notices.from,
                to: state => state.auto_notices.to,
                last_page: state => state.auto_notices.last_page,
                total: state => state.auto_notices.total,
                search_data: state => state.auction_search.search_data,
            }),
        },
        methods: {
            ...mapMutations({
                setSearch: 'auction_search/setSearch',
                destroy: 'auction_search/destroy',
            }),
            dateFormat(value, key, row){
                return window.moment(value).format(this.defaultMomentDateFormat() + ' HH:mm:ss')
            },
            addMember() {
                this.addUser = true;
                this.addUserButton = false;
                this.$nextTick(() => {
                    this.$refs.user_search_input.focus();
                });
            },
            cancelAddMember() {
                this.addUserButton = true;
                this.addUser = false;
            },
            closeEditForm(){
                this.$router.push('/auto-notices')
                this.selected_search = null
            },
            async getData(){
                let data = {
                    sort_by: this.sortBy,
                    sort_desc: this.sortDesc,
                }
                if (this.$route.query.user_id) {
                    data.user_id = this.$route.query.user_id
                }
                let res = await this.$store.dispatch('auto_notices/getAll', data);
                return res;
            },
            getUsers() {
                if (this.userName) {

                    if (this.userSearchCancelToken) {
                        this.userSearchCancelToken.cancel('Request cancelled for new request')
                    }
                    this.userSearchCancelToken = this.axios.CancelToken.source();

                    this.$store.dispatch('users/getUsers', {
                        args: {
                            searchUser: this.userName,
                            sort_asc: 1,
                            per_page: 100,
                            filter_by_statuses: [1,2,3],
                            filter_by_sales_rep: this.salesRep,
                        },
                        cancelToken: this.userSearchCancelToken
                    }).then(response => {
                        this.getUserList = response.data;
                    }).catch(e => console.warn('List/getUsers catch', e));
                } else {
                    this.getUserList = [];
                }
            },
            countPivot(models, field){
                let count = 0
                if (models && models.length) {
                    models.forEach(model => {

                        if (model && model.pivot && model.pivot[field]) {
                            count++
                        }
                    })
                }
                return count
            },
            minMax(value, key, row){
                let min = row.search[key+'_min'] || null;
                let max = row.search[key+'_max'] || null;
                return (min ? min : '') + ' - ' + (max ? max : '')
            },
            openDeletePopper(model){
                let data = JSON.parse(JSON.stringify(this.confirmDelete));
                if (data[model]) {
                    data[model] = false
                } else {
                    data[model] = true
                }
                this.confirmDelete = data
            },
            saveUser(user) {
                let add_user = JSON.parse(JSON.stringify(user));
                if (!add_user.pivot) {
                    add_user.pivot = {
                        send_email: 1,
                        recommend: 1,
                    };
                }
                this.selected_search.users.push(add_user);
                // this.$store.commit('auto_notices/addUser', {
                //     autoNotice: this.selected_search,
                //     user: add_user,
                // });
                this.resetUserAdd();
            },
            removeMember(user) {
                let found = false;
                this.selected_search.users.forEach((item, index) => {
                    if (item.id === user.id) {
                        found = index;
                    }
                });

                if (found !== false) {
                    this.selected_search.users.splice(found, 1);
                }
            },
            resetUserAdd(){
                this.getUserList = [];
                this.userName = '';
                this.addUserButton = true;
                this.addUser = false;
            },
            saveSearch(){
                let search_args = JSON.parse(JSON.stringify(this.search_data));
                let args = { ...search_args, ...this.selected_search};
                if (Object.keys(this.selected_models).length) {
                    let models = ''
                    let i = 0
                    for (let make in this.selected_models) {
                        if (i > 0) {
                            models += '|';
                        }
                        let n = 0;
                        for (let model in this.selected_models[make]) {
                            if (this.selected_models[make][model]) {
                                if (n > 0) {
                                    models += ',';
                                }
                                models += model;
                                n++
                            }
                        }
                        i++;
                    }
                    args.model = models
                }
                this.$store.dispatch('auto_notices/save', args).then(result => {
                    if (result.message) {
                        this.$message.success(result.message);
                        this.selected_search = null;
                        this.getData();
                    } else {
                        this.$message.error('There was a problem saving your search.');
                    }
                }).catch(err => {
                    this.$message.error('There was a problem saving your search.');
                });
            },
            async deleteSearch(search){
                try{
                    let response = await this.$store.dispatch('auto_notices/destroy', search.id);
                    this.$message.success(response.message);
                } catch (e) {
                    let msg = getExceptionErrorMessage(e);
                    this.$message.error(msg);
                }
            },
            excludeMakes(value, key, row){
                return '';
            },
            editAutoNotice(data){
                this.$router.push(`/auto-notices/${data.id}/edit`)
                this.openEditForm(data)
            },
            openEditForm(data){
                let tmp_data = JSON.parse(JSON.stringify(data));
                this.selected_search = tmp_data;
                let searchData = searchDataFromModel(tmp_data);
                this.setSearch(searchData);
            },
            loadAutoNotice (item) {
                this.$store.commit('auction_search/setCurrentPage', 1)
                this.setSearch(item.search)
                window.location.href = this.$laravelRouter('auction')
                return false
            },
            searchAutoNotice (item) {
                this.$store.commit('auction_search/setCurrentPage', 1)
                window.location.href = this.$laravelRouter('search.redirect', item.search.id) + '?autonotice=1'
                return false
            },
            nextDayAutoNotice (item) {
                this.$store.commit('auction_search/setCurrentPage', 1)
                window.location.href = this.$laravelRouter('search.redirect', item.search.id) + '?autonotice=1&next_day=1'
                return false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/AutoNotices/List.vue